module.exports = __webpack_public_path__ + "onboarding-feed-myget.2d1b0c29cc0cc8ec5452976ac206fdb5.hashedasset.svg";